import React from 'react';

const Container = ({ children, className }) => {
  return (
    <div className={'container px-4 mx-auto' + (className ? ` ${className}` : '')}>{children}</div>
  );
};

export default Container;
